import styled from "styled-components";

export const StyledSelectableUpperUnits = styled.form`
	margin: 3rem 0 2rem 0;
	overflow-y: auto;
	max-height: 320px;

	label {
		&:last-child {
			border: none;
		}
	}
`;

export const StyledUpperUnitsInfo = styled.div`
	min-height: 8rem;
	display: flex;
	align-items: center;
	justify-content: center;
`;
